import { isNil } from '@flowio/is';
import {
  AuthorizationsResource,
  CardsResource,
  PublicKeysResource,
  PaymentRequestsResource,
  SessionsResource,
} from '@flowio/api-sdk';
import type {
  $HttpClientOptions,
} from '@flowio/api-sdk';
import SdkAuthorizationsResource from './SdkAuthorizationsResource';
import InternalPaymentRequestsResource from './InternalPaymentRequestsResource';

export interface ApiClient {
  authorizations: AuthorizationsResource;
  sessions: SessionsResource;
  card: CardsResource;
  paymentRequest: PaymentRequestsResource;
  publicKey: PublicKeysResource;
  session: SessionsResource;
}
export interface ApiInternalClient {
  authorizations: SdkAuthorizationsResource;
  paymentRequest: InternalPaymentRequestsResource;
}

let apiClientInstance: ApiClient;
let apiInternalClientInstance: ApiInternalClient;

function getClientOptions(): $HttpClientOptions {
  return {
    fetch: window.fetch.bind(window),
  };
}

export function getApiClient(): ApiClient {
  if (isNil(apiClientInstance)) {
    apiClientInstance = {
      authorizations: new AuthorizationsResource(getClientOptions()),
      sessions: new SessionsResource(getClientOptions()),
      card: new CardsResource(getClientOptions()),
      paymentRequest: new PaymentRequestsResource(getClientOptions()),
      publicKey: new PublicKeysResource(getClientOptions()),
      session: new SessionsResource(getClientOptions()),
    };
  }
  return apiClientInstance;
}

export function getApiInternalClient(): ApiInternalClient {
  if (isNil(apiInternalClientInstance)) {
    apiInternalClientInstance = {
      authorizations: new SdkAuthorizationsResource(getClientOptions()),
      paymentRequest: new InternalPaymentRequestsResource(getClientOptions()),
    };
  }
  return apiInternalClientInstance;
}
